import { render, staticRenderFns } from "./CardPost.pug?vue&type=template&id=a74ec152&scoped=true&lang=pug&"
import script from "./CardPost.vue?vue&type=script&lang=js&"
export * from "./CardPost.vue?vue&type=script&lang=js&"
import style0 from "./CardPost.scss?vue&type=style&index=0&id=a74ec152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74ec152",
  null
  
)

export default component.exports